export default defineNuxtRouteMiddleware((to) => {
	if (process.env.NUXT_PUBLIC_NODE_ENV === 'production') {
		if (
			to.path.startsWith('/partners/auroraenergy') ||
			to.path.startsWith('/partners/sonnendrive')
		) {
			return navigateTo('/', { redirectCode: 307 })
		}
	}
})
